import { CustomTableParams } from '@/models/custom-table-params.model';
import { CustomTableColumn } from '@/models/custom-table-column.model';
import { Vue, Prop, Component } from 'vue-property-decorator';
import { accessObjectByPathHelper } from '@/helpers';
import format from 'date-fns/format';

@Component
export default class CustomTableContent extends Vue {
    @Prop() public inFlight: boolean;
    @Prop() public tableColumns: CustomTableColumn[];
    @Prop() public tableParams: CustomTableParams;
    @Prop() public tableData: any[];

    get paddedData() {
        const data = [...this.tableData];
        data.length = this.tableParams.size;
        return data;
    }

    public handleColumnClicked(data, column) {
        this.$emit('onColumnClicked', { data, column });
    }

    public getDisplayDataForColumn(column: CustomTableColumn, dataItem: any) {
        if (typeof column.accessor === 'string') {

            const accessorSplit = column.accessor.split('|');

            if (accessorSplit.length > 1) {
                return this.resolvePipedData(accessorSplit, dataItem);
            } else {
                return accessObjectByPathHelper(column.accessor, dataItem);
            }
        } else {
            return column.accessor(dataItem);
        }
    }

    private resolvePipedData(accessorSplit: string[], dataItem: any) {
        const accessor = accessorSplit[0];
        const pipeSplit = accessorSplit[1].split(':');
        let pipe: string = '';
        let pipeArgs: string[] = [];

        if (pipeSplit.length > 1) {
            pipe = pipeSplit[0];
            pipeArgs = pipeSplit[1].split(',');
        } else {
            pipe = accessorSplit[1];
        }

        const accessorValue = accessObjectByPathHelper(accessor, dataItem);

        if (
            accessorValue === null ||
            accessorValue === undefined ||
            accessorValue.length <= 0
        ) {
            return '';
        }

        switch (pipe) {
            case 'date':
                return format(new Date(accessorValue), `${this.$t('formats.date')}`);
            case 'datetime':
                return format(new Date(accessorValue), `${this.$t('formats.datetime')}`);
            case 'boolean':
                return accessorValue ? this.$t('actions.yes') : this.$t('actions.no');
            case 'translateOption':
                if (pipeArgs.length > 0 && pipeArgs[0].length > 0) {
                    return this.$t(pipeArgs[0] + '.' + accessorValue);
                } else {
                    console.error('CustomTableContent::resolvePipedData – failed to resolve pipe arguments');
                }
            default:
                return accessorValue;
        }
    }
}
